import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setViewGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_GROUPS_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGroupsViewAction(data.groups));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setViewGroups as SetViewGroups
}